import { useState } from "react";
import MainContainer from "../../components/partials/maincontainer";
import { IconButton } from "../../components/partials/btn";
import DataTable from "../../components/tables";
import DepartmentModal from "../../components/modals/departmentmodal";
import SuccessModal from "../../components/modals/successmodal";
import { useUsersStore } from "../../data/stores/loggerStore";
import { FlowSelectDropdown } from "../../components/partials/select";
import { dataStatus } from "../../utils/types";
import { SearchInput } from "../../components/partials/inputs";

const Department = () => {
  const [activeTab, setActiveTab] = useState("view-all"),
    [setupStatus, setSetUpStatus] = useState(""),
    [modal, setModal] = useState(""),
    [search, setSearch] = useState(""),
    { allData }: any = useUsersStore();

  return (
    <div>
      <MainContainer>
        <div className="bg-transparent main-border main-shadow rounded-lg">
          <div
            style={{
              borderBottom: "1px solid #D7E2EC",
            }}
            className="h-24 w-full px-5 flex justify-between items-center"
          >
            <div>
              <div className="flex gap-2 items-center">
                <h4 className="text-lg font-medium text-sec">Departments</h4>
                <button className="h-6 px-5 bg-[#E6F3FE] rounded-lg text-xs font-medium text-[#2070B8]">
                  {allData?.totalDocs || 0}{" "}
                  {(allData?.totalDocs || 0) > 1 ? "Departments" : "Department"}
                </button>
              </div>
              <p className="text-sm text-es-gray-100 mt-1 font-normal">
                Manage departments and their organizational structure
              </p>
            </div>
            <div className="flex gap-5 items-center">
              <IconButton
                onClick={() => setModal("add-department")}
                icon="material-symbols:add"
                color="white"
                text="New Department"
                bg="#2070B8"
              />
            </div>
          </div>
          <div
            style={{
              borderBottom: "1px solid #D7E2EC",
            }}
            className="h-20 w-full px-5 flex justify-between items-center"
          >
            <div className="inline-flex h-11 rounded-lg main-border overflow-hidden">
              <button
                className={`px-6  text-sm font-medium ${
                  activeTab === "view-all"
                    ? "bg-[#F9FAFB] text-gray-800"
                    : "bg-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveTab("view-all")}
              >
                View all
              </button>
              <div className="h-full w-px bg-[#d0d5dd]" />
              <button
                className={`px-6 text-sm font-medium ${
                  activeTab === "active"
                    ? "bg-[#F9FAFB] text-gray-800"
                    : "bg-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveTab("active")}
              >
                Active
              </button>
              <div className="h-full w-px bg-[#d0d5dd]" />
              <button
                className={`px-6 text-sm font-medium ${
                  activeTab === "inactive"
                    ? "bg-[#F9FAFB] text-gray-800"
                    : "bg-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveTab("inactive")}
              >
                Inactive
              </button>
            </div>
            <div className="flex gap-4 items-center">
              <SearchInput
                value={search}
                onChange={(e) => {
                  setSearch(e);
                }}
              />
              <FlowSelectDropdown
                options={[
                  { title: "All" },
                  ...dataStatus?.map((it) => {
                    return { title: it };
                  }),
                ]}
                onChange={(d: any) => {
                  setSetUpStatus(d?.title === "All" ? "" : d?.title);
                }}
              />
            </div>
          </div>
          <DataTable
            usecase={activeTab}
            setupStatus={setupStatus}
            search={search}
          />
        </div>
      </MainContainer>
      {modal === "add-department" && (
        <DepartmentModal
          handleModal={() => setModal("success")}
          handleClose={() => setModal("")}
        />
      )}
      {modal === "success" && (
        <SuccessModal
          btnText="Return to Departments"
          page="/department"
          title="Department Created"
          desc="The new department has been created successfully and is now available for use."
        />
      )}
    </div>
  );
};

export default Department;
